export enum KBDataEnum {
  CBCRKey = 1,
  LocalFileKey,
  MasterFileKey,
}
